module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0049.jpg?v=ed03eba4";